import React from "react";

const SubtitleGenerationPage = () => {
  return <div>SubtitleGenerationPage</div>;
};

export default SubtitleGenerationPage;